'use strict';

angular.module('mandaeApp')
  .factory('ParametroResource', function ($rootScope, $resource) {
    return $resource($rootScope.URL + $rootScope.PATH + '/parameters/:codigo', {
	      orderId: '@_codigo'
	    }
	);
  });